export default "__VITE_ASSET__Drn$NGHO__"